import React from 'react';
import { motion } from 'framer-motion';
import { Plane, Ticket, Coins, Compass, Globe } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-6 max-w-4xl mx-auto text-center" data-id="element-92">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-93">
        <div className="mt-4 mb-12 bg-brand-brown-light p-12 md:p-16 rounded-[3rem] border-2 border-brand-gold shadow-2xl relative overflow-hidden" data-id="element-94">
          {/* Decorative gold corners */}
          <div className="absolute top-4 left-4 w-12 h-12 border-t-2 border-l-2 border-brand-gold rounded-tl-[2rem]" data-id="element-95"></div>
          <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-brand-gold rounded-tr-[2rem]" data-id="element-96"></div>
          <div className="absolute bottom-4 left-4 w-12 h-12 border-b-2 border-l-2 border-brand-gold rounded-bl-[2rem]" data-id="element-97"></div>
          <div className="absolute bottom-4 right-4 w-12 h-12 border-b-2 border-r-2 border-brand-gold rounded-br-[2rem]" data-id="element-98"></div>

          {/* Floating travel icons — hand-drawn feel in soft gold */}
          <Plane className="absolute top-10 left-10 w-7 h-7 text-brand-gold/30 -rotate-12 pointer-events-none" strokeWidth={1} data-id="element-99" />
          <Ticket className="absolute top-12 right-12 w-7 h-7 text-brand-cream/25 rotate-12 pointer-events-none" strokeWidth={1} data-id="element-100" />
          <Coins className="absolute bottom-16 left-12 w-7 h-7 text-brand-gold/30 -rotate-6 pointer-events-none" strokeWidth={1} data-id="element-101" />
          <Compass className="absolute bottom-14 right-10 w-7 h-7 text-brand-cream/25 rotate-12 pointer-events-none" strokeWidth={1} data-id="element-102" />
          <Globe className="absolute top-1/2 left-6 w-6 h-6 text-brand-gold/25 pointer-events-none hidden md:block" strokeWidth={1} data-id="element-103" />
          <Plane className="absolute top-1/2 right-6 w-6 h-6 text-brand-cream/20 rotate-45 pointer-events-none hidden md:block" strokeWidth={1} data-id="element-104" />

          <img src="https://cdn.magicpatterns.com/uploads/wGuZgXmUeTEHMANTTKmea7/ChatGPT_Image_18_may_2026,_04_05_24_p.m..png" alt="Atajo al Éxito - Mentoría 1:1 by Careliz Griman" className="relative mx-auto w-60 md:w-72 h-auto mb-8 rounded-lg shadow-md" data-id="element-105" />

          <p className="text-sm uppercase tracking-[0.3em] text-brand-gold mb-6 font-medium" data-id="element-106">
            Tu Inversión
          </p>

          <p className="text-6xl md:text-7xl font-serif text-brand-gold mb-2" data-id="element-107">
            <span className="text-3xl align-top mr-2" data-id="element-108">USD</span>
            147
          </p>

          <p className="text-xl md:text-2xl font-serif text-brand-gold/80 italic mb-8" data-id="element-109">
            $ 147.000 ARS
          </p>

          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-110">
            <div className="w-16 h-px bg-brand-gold/60" data-id="element-111"></div>
            <span className="text-brand-gold text-xs" data-id="element-112">✦</span>
            <div className="w-16 h-px bg-brand-gold/60" data-id="element-113"></div>
          </div>

          <p className="text-xl font-serif text-brand-cream italic mb-6" data-id="element-114">
            No estás comprando solo una mentoría.
          </p>

          <p className="text-lg text-brand-cream/80 font-light leading-relaxed max-w-xl mx-auto mb-10" data-id="element-115">
            Estás invirtiendo en:{' '}
            <span className="font-medium text-brand-gold" data-id="element-116">
              claridad, dirección, estrategia, acompañamiento y transformación.
            </span>
            <br data-id="element-117" />
            <br data-id="element-118" />
            Estás invirtiendo en tu{' '}
            <span className="font-medium text-brand-gold" data-id="element-119">
              libertad financiera
            </span>
            , en tu <span className="font-medium text-brand-gold" data-id="element-120">paz</span> y
            en la{' '}
            <span className="font-medium text-brand-gold" data-id="element-121">
              mujer exitosa que sueñas ser.
            </span>
          </p>

          <a href="https://wa.me/message/LI4MMCWOOCMYN1" target="_blank" rel="noopener noreferrer" className="btn-gold-shine inline-block px-10 py-5 rounded-full uppercase tracking-widest text-sm font-bold w-full md:w-auto" data-id="element-122">
            Agenda tu mentoría aquí
          </a>
        </div>
      </motion.div>
    </section>;
}